import React from 'react';
import { Box, Tooltip, IconButton, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { subscriptionStatusConfig } from './SubscriptionStatusBadge';

/**
 * Subscription status row for the admin side nav. Shows the current status +
 * remaining days, collapsing to an icon with a tooltip in the mini drawer.
 * Links to the billing page. Renders nothing until the subscription loads.
 */
export function SubscriptionNavStatus({ mini = false }) {
  const navigate = useNavigate();
  const { subscription, loading } = useSubscription();

  if (loading || !subscription) return null;

  const config = subscriptionStatusConfig(subscription);
  if (!config) return null;

  const { Icon } = config;
  const go = () => navigate('/admin/billing');

  if (mini) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <Tooltip title={config.tooltip} placement="right">
          <IconButton
            onClick={go}
            size="small"
            sx={{ bgcolor: config.bg, '&:hover': { bgcolor: config.bg, filter: 'brightness(0.96)' } }}
          >
            <Icon sx={{ color: config.color, fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 2, pb: 1 }}>
      <Divider sx={{ mb: 1.5, borderColor: 'rgba(0,0,0,0.08)' }} />
      <Box
        onClick={go}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          px: 1.5,
          py: 1,
          borderRadius: '12px',
          cursor: 'pointer',
          bgcolor: config.bg,
          border: `1px solid ${config.color}33`,
          transition: 'filter 0.15s',
          '&:hover': { filter: 'brightness(0.97)' },
        }}
      >
        <Icon sx={{ color: config.color, fontSize: 20, flexShrink: 0 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.2 }}>
            Subscription
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, color: config.color, lineHeight: 1.2 }} noWrap>
            {config.label.replace('Subscription active', 'Active')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default SubscriptionNavStatus;
